
var id = "qr-icon";
var markup = "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"qr-icon\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 12C0 5.3724 5.3724 0 12 0C18.6276 0 24 5.3724 24 12C24 18.6276 18.6276 24 12 24C5.3724 24 0 18.6276 0 12ZM2.4 12C2.4 17.3016 6.6984 21.6 12 21.6C17.3016 21.6 21.6 17.3016 21.6 12C21.6 6.6984 17.3016 2.4 12 2.4C6.6984 2.4 2.4 6.6984 2.4 12Z\" fill=\"#1B60AD\" />\n<rect x=\"7\" y=\"7\" width=\"3\" height=\"3\" rx=\"1\" stroke=\"#1B60AD\" stroke-width=\"2\" />\n<rect x=\"7\" y=\"14\" width=\"3\" height=\"3\" rx=\"1\" stroke=\"#1B60AD\" stroke-width=\"2\" />\n<rect x=\"14\" y=\"7\" width=\"3\" height=\"3\" rx=\"1\" stroke=\"#1B60AD\" stroke-width=\"2\" />\n<rect x=\"13\" y=\"13\" width=\"1\" height=\"2.5\" rx=\"0.5\" fill=\"#1B60AD\" />\n<rect x=\"13\" y=\"16\" width=\"1\" height=\"2\" rx=\"0.5\" fill=\"#1B60AD\" />\n<rect x=\"15\" y=\"16\" width=\"1\" height=\"2\" rx=\"0.5\" fill=\"#1B60AD\" />\n<rect x=\"17\" y=\"16\" width=\"1\" height=\"1\" rx=\"0.5\" fill=\"#1B60AD\" />\n<rect x=\"15\" y=\"13\" width=\"1\" height=\"2.5\" rx=\"0.5\" fill=\"#1B60AD\" />\n<rect x=\"17\" y=\"13\" width=\"1\" height=\"2.5\" rx=\"0.5\" fill=\"#1B60AD\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
